module.exports = __webpack_public_path__ + "img/starthouse_bodyimage02.4d10bfdb.jpg";